import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment';

import UserProfileService from '../services/UserProfiles';
import FieldApi from '../services/field/FieldApi';
import FieldService from '../services/field/FieldService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import LocalStorageService from '../services/utilities/LocalStorageService';

import * as FormEle from '../components/FieldFormElements';
import * as FormEleCcus from '../components/FieldFormElementsCcus';
import { Confirmation, Information } from '../components/modals/common';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { BankenInfoDialog } from '../components/modals/BankenInfoDialog';
import { FieldFormCcusCheckbox } from '../components/FieldFormCcusCheckbox';
import { FieldCcusForm } from '../components/forms/FieldCcusForm'; // Ccusフォーム
import { ccusStore } from '../components/FieldFormElementsCcusProvider'; // Ccusフォーム
import {
  createFormEventManager,
  Form,
  SwitchForm,
} from '../components/FormBase';
import {
  FieldCcusRegisterDialog,
  FieldCcusRegisterDialogPromise,
  CcusRegisterDialogProvider,
} from '../components/modals/FieldCcusRegisterDialog';

import _masterSlideLoader from '../utilities/masterSlideLoader';
import { validationByJoi } from '../utilities/commonValidation';
import {
  FieldScheme,
  FieldCcusScheme,
  FieldCopyScheme,
} from '../utilities/JoiSchemes';
import { isTargetRoleId, isLoginUserPartner } from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import {
  USER_ROLES,
  HEADER_CONSTANTS,
  FIELD_WORK_HOUR_ZONES,
  LOCK_MAX_DAYS,
  FIELD_INPUT_RESULT,
  FIELD_ADJUST_WORK_PRINT,
  FIELD_CRANE_USE_PRINT,
  FIELD_WORK_AND_DIARY_PRINT,
  CCUS_ORDER_TYPE,
  CCUS_CONSTRUCTURE_TYPE,
  CONTRACT_FLAG,
  INIT_WORK_TIME,
  API_FLAG,
  COPY_FIELD_ADDRESS_TARGET,
} from '../utilities/constants';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';

import { matchFormatDateSlash } from '../utilities/commonUtil';
import { MasterPageHeader } from '../components/PageHeader';
import {
  FormList,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { CcusTitleBlock } from '../components/CcusFormComponent';
import dialogLoader from '../utilities/dialogLoader';
import { CloseEditView } from '../components/CloseEditView';
import { FieldNaviList } from '../components/list/FieldNaviList';
import { FormInformationDialog } from '../components/FormInformationDialog';

moment.locale('ja');

/**
 * @description 新規現場登録、新規現場登録申請画面
 */
export class FieldRegister extends React.Component {
  constructor(props) {
    super(props);
    /* eslint-disable no-multi-spaces */
    this.defaultFieldCcusData = {
      field: {},
      ccus_field_id: null,
      ccus_field_managers: {},
    };
    this.state = {
      validate: {}, // バリデーションメッセージを格納
      params: {}, // 現場情報を保持
      company: {}, // 元請会社情報を保持
      company_branch: {}, // 支店を保持
      showModal: false, // 投稿成功
      updateSuccess: false, // 投稿成功
      updateMsg: null, // 投稿成功メッセージ
      updateTitle: null,
      ccus_register_flg: false, // CCUS登録フラグ
      ccus_disable_checkbox: false, // CCUS情報取得
      ccusRegisterDialogShow: false, // 現場登録後にCCUSに登録中のダイアログを表示するフラグ
      duplicateRequestDialogShow: false, // 多重送信検知のダイアログを表示するフラグ
      isShowClearCcusDataConfirmDialog: false,
      ccus_field_data: this.defaultFieldCcusData, //CCUS情報を格納
      ccusSecededFlag: false,
      isShowBankenInfoDialog: false,
    };
    this.ccus_field_to_be_check = [
      'ordering_type_id',
      'construction_type_id',
      'manager_id',
    ];

    // state.params の初期値の設定
    this.initStateParams = {
      work_hour_zone_day_flag: FIELD_WORK_HOUR_ZONES.on.id, // 作業時間帯_昼間
      work_hour_zone_night_flag: FIELD_WORK_HOUR_ZONES.on.id, // 作業時間帯_夜間
      earlytime_end: INIT_WORK_TIME.earlytime_end, // 労働開始時刻_昼間
      earlytime_end_night: INIT_WORK_TIME.earlytime_end_night, // 労働開始時刻_夜間
      overtime_start: INIT_WORK_TIME.overtime_start, // 労働終了時刻_昼間
      overtime_start_night: INIT_WORK_TIME.overtime_start_night, // 労働終了時刻_夜間
      work_start_time: INIT_WORK_TIME.work_start_time, // 作業時間帯バー開始時刻_昼間
      work_start_time_night: INIT_WORK_TIME.work_start_time_night, // 作業時間帯バー開始時刻_夜間
      work_end_time: INIT_WORK_TIME.work_end_time, // 作業時間帯バー終了時刻_昼間
      work_end_time_night: INIT_WORK_TIME.work_end_time_night, // 作業時間帯バー終了時刻_夜間
      work_copy_time: INIT_WORK_TIME.work_copy_time, // 予定→実施入力反映時刻_昼間
      work_copy_time_night: INIT_WORK_TIME.work_copy_time_night, // 予定→実施入力反映時刻_夜間
      partner_input_result_flag: FIELD_INPUT_RESULT.on.id, // 作業実績の入力を促す表示_協力会社
      adjust_work_print_flag: FIELD_ADJUST_WORK_PRINT.separate.id, // 作業安全指示書とKY記録表の印刷方法
      crane_use_print_flag: FIELD_CRANE_USE_PRINT.side.id, // 揚重作業計画・作業指示書の印刷向き
      work_and_diary_print_flag: FIELD_WORK_AND_DIARY_PRINT.adjustment.id, // 作業間連絡及び調整実施記録（安全衛生日誌有）の印刷方法
    };

    // initStateParamsは単なる初期値だけではなく、EventMgの仕組みに巻き込まれて
    // 他の値が変更された時にこの初期値に戻される動きがあるので
    // initStateparams以外で初期化する値は下記で記載する
    this.state.params.use_entrance_flg = null; // 入退場管理機能ON/OFF
    this.state.params.changeable_entrance_flg = false; // 入退場管理機能Enabled/Disabled
    this.state.params.use_greenfile_flg = null; // 労務安全機能ON/OFF
    this.state.params.changeable_greenfile_flg = false; // 労務安全機能Enabled/Disabled
    this.state.params.use_progress_flg = null; // 進捗歩掛機能ON/OFF
    this.state.params.changeable_progress_flg = false; // 進捗歩掛機能Enabled/Disabled

    /* eslint-enable no-multi-spaces */
    /* eslint-enable prettier/prettier */

    // Form で使うEventManagerを取得
    this.FormEventMg = createFormEventManager();

    // slideLoaderからの情報を取得
    if (props.view) {
      this.field_id = props.view.state.id;
    } else if (props.match) {
      this.field_id = props.match.params.id;
    }

    this.role_id = LocalStorageService.getRoleId(); // ロールID
    this.user_id = LocalStorageService.getUserId(); // ユーザーID
    this.submitRef = React.createRef(); // 登録ボタン要素
    this.isManagerRoll = isTargetRoleId([USER_ROLES.manager], this.role_id);
    this.updatingFlag = false; // 多重登録防止用Flag

    //カレンダー
    this.FormCalendar = null;

    // buildeeとの契約無しの状態で、URL直叩き遷移防止処理
    const contractFlag = SessionStorageService.getContractFlag();
    if (
      contractFlag === CONTRACT_FLAG.noContract.id &&
      isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], this.role_id)
    ) {
      return window.location.replace('/error-permission');
    }
  }

  UNSAFE_componentWillMount() {
    ccusStore.destroy();
    this.getCompanyBase();
  }

  componentDidMount() {
    // console.log('FieldRegister.jsx componentDidMount');

    // 初期値を設定
    _.each(this.initStateParams, (value, key) => {
      this.FormEventMg.trigger('input_change_value', {
        id: key,
        value,
      });
    });

    //現場監督なら buildee_user_id を自分のidに
    if (this.isManagerRoll) {
      this.FormEventMg.trigger('input_change_value', {
        id: 'buildee_user_id',
        value: this.user_id,
      });
    }

    //個々のバリデートをうけとる
    this.FormEventMg.addEventListener('update_validate', this.eachValidate);
    this.FormEventMg.addEventListener('change_value', (id, params) => {
      if (!Object.keys(params).length) {
        return;
      }
      // console.log('FieldRegister.jsx change_value', id, params);
      // 連続で実行されることにより1つ前のstateの変更が消えてしまうためメソッドの引数にして最新のstateを保証する
      // state内にオブジェクトで持っているせいでマージ処理が必ず発生することが要因(flatteなら起きなかった問題)
      this.setState(prevState => ({
        params: { ...prevState.params, ...params },
      }));
    });
  }

  componentWillUnmount() {
    this.FormEventMg.deleteEvent('change_value');
    this.FormEventMg.deleteEvent('input_change_value');
    this.FormEventMg.deleteEvent('update_validate');
  }

  /**
   * @description 元請会社情報を取得
   */
  async getCompanyBase() {
    UserProfileService.show(this.user_id)
      .then(response => {
        // console.log(
        //   'FieldRegister.jsx getCompanyBase UserProfileService.show',
        //   response
        // );
        if (response.result) {
          let company, company_branch;
          const ccusSecededFlag = _.get(
            response,
            'data.entities.company[0].ccus_seceded_flag'
          );
          if (isLoginUserPartner()) {
            const sessionPrimeCompanyId = SessionStorageService.getItem(
              'sessionPartnerCompanyIdOfPrimeCompany'
            );
            if (sessionPrimeCompanyId) {
              company = _.find(response.data.entities.company, company => {
                return String(company.id) === sessionPrimeCompanyId;
              });
            }
          } else {
            company = response.data.entities.company[0];
          }

          // 支店管理者と現場監督の時だけ
          if (
            isTargetRoleId(
              [USER_ROLES.branch, USER_ROLES.manager],
              this.role_id
            )
          ) {
            company_branch = response.data.entities.company_branch[0];
          } else {
            company_branch = {};
          }
          this.setState({ company, company_branch, ccusSecededFlag });
        } else {
          alert(response.message);
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  /***
   * @description 各バリデーション系メソッドに遷移させ、エラーメッセージをセット
   * @param {object} values id: 入力フォームID, params: 全入力パラメータ
   */
  eachValidate = values => {
    // console.log(
    //   'FieldRegister.jsx eachValidate 1',
    //   values,
    //   this.state.ccus_register_flg
    // );

    const { id, params, ccusChecked } = values;
    const state = _.cloneDeep(this.state);

    this.workTimeInputCheck(params.work_hour);

    let result = validationByJoi(
      //ccus登録でスキーマを切り替え
      this.state.ccus_register_flg ? FieldCcusScheme : FieldScheme,
      params
    );
    const _validate = _.cloneDeep(this.state.validate);
    result = this.checkValidate(result, params);
    // console.log('FieldRegister.jsx eachValidate 2', result);

    if (result.status === false && !_.isEmpty(result.messages[id])) {
      // 入力項目に誤りがある場合、エラーメッセージをセット
      _validate[id] = result.messages[id];
    } else {
      // 正常に入力している場合、エラーメッセージを削除
      delete _validate[id];
    }

    if (_.has(result.messages, 'work_hour_type')) {
      // 作業時間帯を1つもチェックしていない場合、エラーメッセージをセット
      _validate.work_hour_type = result.messages.work_hour_type;
    } else {
      // 作業時間帯を1つ以上チェックしている場合、エラーメッセージを削除
      delete _validate.work_hour_type;
    }

    if (id === 'complete_schedule_date' && params['groundbreaking_date']) {
      result.messages.groundbreaking_date
        ? (_validate.groundbreaking_date = result.messages.groundbreaking_date)
        : delete _validate.groundbreaking_date;
    }

    if (ccusChecked === false) {
      _.each(this.ccus_field_to_be_check, field => {
        delete _validate[field];
      });
    }
    state.validate = _validate;
    state.params[id] = params[id];
    this.setState(state);
  };

  /**
   * @description 1日あたりの労働時間（作業員, 社員時間）フォーム入力チェック
   * @param {object} work_hour 1日あたりの労働時間入力パラメータ
   * @returns バリデーションチェック処理後の全入力パラメータオブジェクト
   */
  workTimeInputCheck(work_hour) {
    // 選択後、未選択に切り替えていた場合、要素を削除
    _.each(work_hour, param => {
      if (param.worker_work_time === 'false') {
        delete param.worker_work_time;
      }
      if (param.manager_work_time === 'false') {
        delete param.manager_work_time;
      }
    });
  }

  /***
   * @description 詳細な相関バリデーションチェック
   * @param {object} result Joiで取得したエラーメッセージ
   * @param {object} params 全入力パラメータ
   * @returns バリデーションチェック後のエラーメッセージオブジェクト
   */
  checkValidate = (result, params) => {
    result.messages = result.messages || {};

    // console.log('FieldRegister.jsx checkValidate', result, params);

    if (matchFormatDateSlash(params.usage_end_date)) {
      if (
        moment(params.usage_end_date, 'YYYY/MM/DD').isBefore(moment(), 'day')
      ) {
        result.status = false;
        result.messages.usage_end_date =
          '今日よりあとの日付を入力してください。';
      }
    }

    if (params.groundbreaking_date || params.complete_schedule_date) {
      if (
        moment(params.groundbreaking_date, 'YYYY/MM/DD').isAfter(
          moment(params.complete_schedule_date, 'YYYY/MM/DD')
        )
      ) {
        result.status = false;
        result.messages['groundbreaking_date'] = messageUtility.getMessage(
          'E-000-015'
        );
      } else {
        params.groundbreaking_date &&
          delete result.messages['groundbreaking_date'];
      }
    }
    const keys = [
      'work_hour_zone_day_flag',
      'work_hour_zone_night_flag',
      'work_hour_zone_midnight_flag',
    ];
    _.remove(keys, function(flag) {
      return !params[flag];
    });
    if (keys.length === 0) {
      result.status = false;
      result.messages.work_hour_type = messageUtility.getMessage('E-000-008');
    }
    for (let i in keys) {
      let key = keys[i];
      if (params[key]) {
        let _key = key.match(/(_night|_midnight)/);
        _key = _key ? _key[1] : '';
        let res = this.checkTimeSelectValue(params, _key);
        _.each(res, item => {
          result.status = false;
          result.messages[item] = messageUtility.getMessage('E-000-016');
        });
      }
    }

    if (_.isArray(params.work_hour)) {
      result.messages.work_hour = result.messages.work_hour || {};
      const hour = params.work_hour;
      for (let i = 0; i < hour.length; i += 1) {
        if (
          hour[i + 1] &&
          moment(hour[i + 1].start_date, 'YYYY/MM/DD').isSameOrBefore(
            moment(hour[i].start_date, 'YYYY/MM/DD')
          ) // 下の開始日が上より前だったら
        ) {
          if (result.messages.work_hour[i + 1]) {
            result.messages.work_hour[
              i + 1
            ].start_date = messageUtility.getMessage('E-000-009');
          } else {
            result.messages.work_hour[i + 1] = {
              start_date: messageUtility.getMessage('E-000-009'),
            };
          }
          result.status = false;
        }
      }

      if (_.isEmpty(result.messages.work_hour)) {
        delete result.messages.work_hour;
      }
    }

    if (!_.isUndefined(params.approval_days)) {
      // 自動ロックまでの日数が入力されている場合
      result.messages.approval_days = result.messages.approval_days || {};
      const inputDays = Number(params.approval_days);
      if (!_.isEmpty(result.messages.approval_days)) {
        // 半角数字以外を入力した場合
        result.status = false;
        result.messages.approval_days = messageUtility.getMessage('E-000-017');
      } else if (inputDays > LOCK_MAX_DAYS) {
        // LOCK_MAX_DAYSで指定された日数を超えた場合
        result.status = false;
        result.messages.approval_days = messageUtility.getMessage(
          'E-000-018',
          LOCK_MAX_DAYS
        );
      }

      if (_.isEmpty(result.messages.approval_days)) {
        delete result.messages.approval_days;
      }
    }

    if (params.jvs) {
      result.messages.jvs = result.messages.jvs || {};

      let branch_ids = _.map(
        params.jvs,
        jv => `${jv.company_id}-${jv.company_branch_id}`
      );

      _.each(branch_ids, (id, i) => {
        if (branch_ids.indexOf(id) !== i) {
          result.messages.jvs[i] = messageUtility.getMessage('E-000-019');
          result.status = false;
        }
      });

      if (_.isEmpty(result.messages.jvs)) {
        delete result.messages.jvs;
      }
    }

    return result;
  };

  /***
   * @description 作業時間帯時刻バリデーションチェック
   * @param {object} params 全入力パラメータ
   * @param {string} type 検索用キータイプ
   * @returns 未入力の作業時間帯時刻配列
   */
  checkTimeSelectValue(params, type = '') {
    const result = [];
    const keys = [
      'work_copy_time',
      'work_end_time',
      'work_start_time',
      'earlytime_end',
      'overtime_start',
    ];

    for (let i in keys) {
      const key = `${keys[i]}${type}`;
      if (_.isUndefined(params[key]) || params[key] === 'false') {
        result.push(key);
      }
    }

    return result;
  }

  /**
   * @description BLDE_V2-48023 BANKEN案内ダイアログを表示させる条件チェック
   * @returns {boolean} すべての条件を満たせばtrue、そうでなければfalse
   */
  shouldShowBankenDialog = () => {
    // 入退場管理フラグ
    const useEntranceFlagIsOn =
      this.state.params.use_entrance_flg === API_FLAG.On;

    return useEntranceFlagIsOn;
  };

  /**
   * @description ccusの値をステートに保持
   * @param {object} data
   */
  setCcusFieldData(data) {
    const state = { ...this.state };
    state.ccus_field_data = _.cloneDeep(data);
    if (
      state.ccus_field_data.ccus_field_id !== undefined &&
      state.ccus_field_data.ccus_field_id !== null
    ) {
      state.ccus_disable_checkbox = true;
      state.ccus_register_flg = false;
    } else {
      state.ccus_disable_checkbox = false;
    }
    this.setState(state, () => {
      _.each(this.ccus_field_to_be_check, id => {
        this.eachValidate({
          id,
          params: this.state.params,
          ccusChecked: false,
        });
      });
    });
  }

  /**
   * @description clear ccus data and close confirm dialog
   */
  clearCcusDataAndCloseConfirmDialog = () => {
    this.setState({
      ccus_field_data: this.defaultFieldCcusData,
      isShowClearCcusDataConfirmDialog: false,
    });
  };

  validateCopyFieldAddress = () => {
    const schemaResult = validationByJoi(FieldCopyScheme, this.state.params);
    const result = this.checkValidate(schemaResult, this.state.params);
    let { validate } = _.cloneDeep(this.state);
    const validated = _.filter(COPY_FIELD_ADDRESS_TARGET, input => {
      return !_.has(result.messages, input);
    });
    validate = _.omit(validate, validated);
    // 事務所情報のバリデーションが成功された場合、既存のthis.state.validateから削除する
    // 事務所情報のバリデーションで失敗した項目をthis.state.validateに統合する
    validate = {
      ...validate,
      ...result.messages,
    };
    this.setState({ validate });
  };

  validate = () => {
    const stateValue = _.cloneDeep(this.state);
    let result = validationByJoi(
      stateValue.ccus_register_flg ? FieldCcusScheme : FieldScheme,
      stateValue.params
    );
    result = this.checkValidate(result, stateValue.params);
    if (!result.status) {
      this.setState({ validate: result.messages });
      return false;
    } else {
      return true;
    }
  };

  /**
   * @description 入力した値を送信する
   */
  submit = () => {
    // 多重登録防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;
    // 以下、途中で処理が終了することがあればupdatingFlagをfalseに

    // console.log('FieldRegister.jsx submit 1', this.state.params);

    const stateValue = _.cloneDeep(this.state);
    if (!_.has(stateValue.params, 'postal_code')) {
      stateValue.params.postal_code = '';
    }
    this.workTimeInputCheck(stateValue.params.work_hour);

    // 開発中に入力が手間なので、バリデート処理をOFFにするフラグ
    const developMode = false;
    if (developMode === false) {
      //バリデーション
      //ccus登録でスキーマを切り替え
      let result = validationByJoi(
        stateValue.ccus_register_flg ? FieldCcusScheme : FieldScheme,
        stateValue.params
      );
      result = this.checkValidate(result, stateValue.params);
      if (!result.status) {
        this.setState({ validate: result.messages });
        this.updatingFlag = false;
        return;
      }
      if (!this.validate()) {
        this.updatingFlag = false;
        return;
      } else {
        const obj = document.getElementById('new-field-btn-submit');
        if (obj.disabled) {
          this.updatingFlag = false;
          return;
        }
        obj.disabled = true;
        stateValue.validate = {};
        this.submitRef.current.disabled = true;

        FieldService.createRegisterParams(stateValue, this.role_id);
        this.setState(stateValue);
      }
    } else {
      // console.log('FieldRegister.jsx submit 2', stateValue.params);
      stateValue.params = {
        address_add_1: '1',
        address_add_1_kana: 'イチ',
        address_city: '港区',
        address_city_kana: 'ミナトク',
        address_prefecture: '東京都',
        address_prefecture_kana: 'トウキョウト',
        adjust_work_print_flag: 0,
        approval_days: '3',
        approval_flag: 0,
        buildee_user_id: 198465,
        ccus_register_flg: false,
        charge_name: 'テスト所長名',
        charge_name_kana: 'てすとしょちょうめい',
        company_branch_id: 197343,
        complete_schedule_date: '2020/07/29',
        crane_use_print_flag: 0,
        earlytime_end: '08:00:00',
        earlytime_end_night: '20:00:00',
        groundbreaking_date: '2020/07/28',
        management_no: '098789789789',
        name: `テスト工事現場${moment().format('MM/DD-HH:mm')}`,
        office_address_add_1: '1',
        office_address_add_1_kana: 'イチ',
        office_address_city: 'ちば',
        office_address_city_kana: 'チバ',
        office_address_prefecture: '千葉県',
        office_address_prefecture_kana: 'チバケン',
        office_postal_code: '222-3333',
        overtime_start: '17:00:00',
        overtime_start_night: '05:00:00',
        partner_input_result_flag: 1,
        postal_code: '111-2222',
        start_day: '1',
        tel: '01-1234-5678',
        use_partner_company_approval_flag: 1,
        work_and_diary_print_flag: 0,
        work_copy_time: '00:00:00',
        work_copy_time_night: '12:00:00',
        work_end_time: '21:00:00',
        work_end_time_night: '08:00:00',
        work_hour: [
          {
            end_date: '2020/07/26',
            manager_work_time: '08:00:00',
            start_date: '2020/07/27',
            worker_work_time: '08:00:00',
          },
        ],
        work_hour_zone_day_flag: 1,
        work_hour_zone_night_flag: 1,
        work_start_time: '06:00:00',
        work_start_time_night: '18:00:00',
        use_entrance_flg: stateValue.params.use_entrance_flg,
        use_greenfile_flg: stateValue.params.use_greenfile_flg,
        use_progress_flg: stateValue.params.use_progress_flg,
        usage_end_date: stateValue.params.usage_end_date,
      };
    }
    let isShowDefaultModal = true;

    FieldApi.registerField(stateValue.params)
      .then(response => {
        if (response.result) {
          stateValue.updateSuccess = true;
          stateValue.updateTitle = this.isManagerRoll
            ? messageUtility.getMessage('I-000-116')
            : messageUtility.getMessage('I-000-112');
          stateValue.updateMsg = this.isManagerRoll
            ? messageUtility.getMessage('I-000-117')
            : messageUtility.getMessage('I-000-113');
        } else {
          if (response.message === messageUtility.getMessage('E-000-078')) {
            isShowDefaultModal = false;
            return dialogLoader.show(FormInformationDialog, {
              title: messageUtility.getMessage('E-000-077'),
              message: messageUtility.getMessage('E-000-078'),
              onClose: () => {
                this.submitRef.current.disabled = false;
                dialogLoader.close();
              },
            });
          }

          stateValue.updateSuccess = false;
          this.submitRef.current.disabled = false;
          if (!_.isNil(response.message)) {
            stateValue.updateMsg = response.message;
            if (
              response.status === 400 &&
              response.message &&
              response.message.includes(messageUtility.getMessage('E-000-052'))
            ) {
              stateValue.duplicateRequestDialogShow = true;
            }
          } else {
            stateValue.updateMsg = messageUtility.getMessage('E-000-006');
          }
        }
      })
      .catch(error => {
        alert(error);
        this.submitRef.current.disabled = false;
        stateValue.updateSuccess = false;
        stateValue.updateMsg = messageUtility.getMessage('E-000-006');
      })
      .finally(() => {
        if (!stateValue.duplicateRequestDialogShow && isShowDefaultModal) {
          stateValue.showModal = true;
        }
        this.setState(stateValue);
        this.updatingFlag = false;
      });
  };

  /**
   * @description ccusにも登録するチェックボックス
   */
  onChangeCcusCheckbox = async () => {
    _.each(this.ccus_field_to_be_check, id => {
      this.eachValidate({
        id,
        params: this.state.params,
        ccusChecked: !this.state.ccus_register_flg,
      });
    });
    if (this.state.ccus_register_flg) {
      this.setState({
        ccus_register_flg: false,
      });
      return;
    }

    const ccus_result = await FieldCcusRegisterDialogPromise.show();
    if (ccus_result) {
      this.setState({
        ccus_register_flg: true,
      });
    } else {
      this.setState({
        ccus_register_flg: false,
      });
    }
  };

  openCloseEditModal = () => {
    dialogLoader.show(CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          ccusStore.destroy();
          _masterSlideLoader.show('Fields', {
            state: {},
          });
          dialogLoader.close();
        },
      },
    });
  };

  copyFieldAddress = () => {
    const params = {
      office_postal_code: this.state.params.postal_code,
      office_address_prefecture: this.state.params.address_prefecture,
      office_address_prefecture_kana: this.state.params.address_prefecture_kana,
      office_address_city: this.state.params.address_city,
      office_address_city_kana: this.state.params.address_city_kana,
      office_address_add_1: this.state.params.address_add_1,
      office_address_add_1_kana: this.state.params.address_add_1_kana,
      office_address_add_2: this.state.params.address_add_2,
      office_address_add_2_kana: this.state.params.address_add_2_kana,
    };
    this.setState(
      {
        params: {
          ...this.state.params,
          ...params,
        },
      },
      () => {
        _.each(COPY_FIELD_ADDRESS_TARGET, input => {
          this.FormEventMg.trigger('input_change_value', {
            id: input,
            value: params[input],
          });
        });
        this.validateCopyFieldAddress();
      }
    );
  };

  render() {
    // console.log('FieldRegister.jsx render', this.state, this.state.params);

    const { validate, company, ccusSecededFlag } = this.state;

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 新規現場登録</title>
        </Helmet>

        <div className='contruction-slide-view__view'>
          <FormTopHeader
            role_id={this.role_id}
            close={this.openCloseEditModal}
          />

          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <FieldNaviList
                  fieldId={null}
                  selectedTab='FieldRegister'
                  disabledCooperationCcus={true}
                />
              </div>

              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__header'>
                  <button
                    className='btn-text--sm'
                    onClick={this.openCloseEditModal}
                  >
                    <i className='i-back--blue i-2x vertical-middle' />
                    現場一覧
                  </button>
                </div>

                <FormViewMenu
                  validate={validate}
                  checkValidate={this.checkValidate}
                  EventMg={this.FormEventMg}
                  role_id={this.role_id}
                  submitRef={this.submitRef}
                  params={this.state.params}
                  disabledCheckbox={this.state.ccus_disable_checkbox}
                  ccusChecked={this.state.ccus_register_flg}
                  onChangeCcusCheckbox={this.onChangeCcusCheckbox}
                  ccusSecededFlag={ccusSecededFlag}
                />

                <div className='contruction-detail-view__bar' />

                {/* ここからフォーム */}
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed set-width-dropdown'>
                  <FormList>
                    <FieldCcusForm
                      ccusid={this.state.ccus_field_data.ccus_field_id}
                      setCcusFieldData={data => {
                        this.setCcusFieldData(data);
                      }}
                      updateFormValue={(key, value) => {
                        this.FormEventMg.trigger('input_change_value', {
                          id: key,
                          value,
                        });
                      }}
                      validate={validate}
                      setValidate={(validate, callback) => {
                        this.setState({ validate }, () => {
                          callback();
                        });
                      }}
                      fieldName={this.state.params.name}
                      ccusSecededFlag={ccusSecededFlag}
                    />
                    <Form EventMg={this.FormEventMg} submit={this.submit}>
                      {this.state.ccus_field_data.ccus_field_id && (
                        <FormEle.CcusId
                          defaultValue={
                            this.state.ccus_field_data.ccus_field_id
                          }
                          isShowDeleteButton={true}
                          onDelete={() =>
                            this.setState({
                              isShowClearCcusDataConfirmDialog: true,
                            })
                          }
                        />
                      )}
                      <FormEle.CompanyName defaultValue={company.name} />
                      <FormEle.CompanyBranch
                        id='company_branch_id'
                        disabled={isTargetRoleId(
                          [USER_ROLES.branch, USER_ROLES.manager],
                          this.role_id
                        )}
                        validate={validate.company_branch_id}
                        defaultValue={null}
                        usersPartnerForm={true}
                        needConfirm={
                          this.state.params.buildee_user_id ||
                          _.size(
                            _.filter(this.state.params.jvs, function(jv) {
                              return !!jv.company_id;
                            })
                          ) > 0
                        }
                        onChangeCompanyBranch={value => {
                          // 支店プルダウン切替に対応して
                          // 「入退場」「労務安全」のEnabledを切り替える処理

                          const {
                            available_entrance_flg,
                            available_greenfile_flg,
                            available_progress_flg,
                            default_use_entrance_flg,
                            default_use_progress_flg,
                            cannot_off_greenfile_flg,
                          } = value;

                          let default_use_greenfile_flg =
                            value.default_use_greenfile_flg;

                          if (cannot_off_greenfile_flg) {
                            default_use_greenfile_flg = true;
                          }

                          // console.log(
                          //   'FieldRegister.jsx FormEle.CompanyBranch onChangeCompanyBranch',
                          //   value
                          // );
                          // 連続で実行されることにより1つ前のstateの変更が消えてしまうためメソッドを引数にして最新のstateを保証する
                          this.setState(prevState => ({
                            params: {
                              ...prevState.params,
                              buildee_user_id: null, //支店変更したため紐づく担当者も未設定にする
                              changeable_entrance_flg:
                                available_entrance_flg === true,
                              use_entrance_flg:
                                default_use_entrance_flg === true
                                  ? API_FLAG.On
                                  : default_use_entrance_flg === false
                                  ? API_FLAG.Off
                                  : null,
                              changeable_greenfile_flg:
                                available_greenfile_flg === true,
                              use_greenfile_flg:
                                default_use_greenfile_flg === true
                                  ? API_FLAG.On
                                  : default_use_greenfile_flg === false
                                  ? API_FLAG.Off
                                  : null,
                              changeable_progress_flg:
                                available_progress_flg === true,
                              use_progress_flg:
                                default_use_progress_flg === true
                                  ? API_FLAG.On
                                  : default_use_progress_flg === false
                                  ? API_FLAG.Off
                                  : null,
                              cannot_off_greenfile_flg,
                            },
                          }));
                        }}
                        isRequireIconShow={true}
                      />
                      <FormEleCcus.FieldName
                        id='name'
                        validate={validate.name}
                        defaultValue={''}
                        ccusValue={this.state.ccus_field_data.field.name}
                      />
                      <FormEleCcus.FieldSelectCommon
                        id='ordering_type_id'
                        labelTitle={'発注区分'}
                        placeholder={'発注区分を指定'}
                        items={_.map(Object.keys(CCUS_ORDER_TYPE), item => {
                          return CCUS_ORDER_TYPE[item];
                        })}
                        validate={validate.ordering_type_id}
                        defaultValue={''}
                        ccusValue={
                          this.state.ccus_field_data.field.ordering_type_id
                        }
                        ccusRequired={this.state.ccus_register_flg}
                        isFormListDefaultItem={true}
                      />
                      <FormEleCcus.FieldSelectCommon
                        id='construction_type_id'
                        labelTitle={'工事種類'}
                        placeholder={'工事種類を指定'}
                        items={_.map(
                          Object.keys(CCUS_CONSTRUCTURE_TYPE),
                          item => {
                            return CCUS_CONSTRUCTURE_TYPE[item];
                          }
                        )}
                        validate={validate.construction_type_id}
                        defaultValue={''}
                        ccusValue={
                          this.state.ccus_field_data.field.construction_type_id
                        }
                        ccusRequired={this.state.ccus_register_flg}
                        isFormListDefaultItem={true}
                      />
                      <FormListSubHeader
                        title={'現場情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                      />
                      <FormEleCcus.FieldPostalCode
                        id='postal_code'
                        validate={validate.postal_code}
                        ccusValue={this.state.ccus_field_data.field.postal_code}
                        ccusRequired={this.state.ccus_register_flg}
                      />
                      <FormEleCcus.FieldPrefecture
                        id='address_prefecture'
                        validate={validate.address_prefecture}
                        defaultValue={''}
                        ccusValue={
                          this.state.ccus_field_data.field.address_prefecture
                        }
                        ccusRequired={this.state.ccus_register_flg}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_city'
                        labelTitle={'市区町村'}
                        placeholder={messageUtility.getMessage('I-000-190')}
                        maxLength={60}
                        validate={validate.address_city}
                        ccusValue={
                          this.state.ccus_field_data.field.address_city
                        }
                        ccusRequired={this.state.ccus_register_flg}
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_city_kana'
                        labelTitle={'市区町村(フリガナ)'}
                        placeholder={messageUtility.getMessage('I-000-193')}
                        maxLength={60}
                        validate={validate.address_city_kana}
                        ccusValue={
                          this.state.ccus_field_data.field.address_city_kana
                        }
                        ccusRequired={this.state.ccus_register_flg}
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_1'
                        labelTitle={messageUtility.getMessage('I-000-189')}
                        placeholder={messageUtility.getMessage('I-000-192')}
                        maxLength={120}
                        validate={validate.address_add_1}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_1
                        }
                        ccusRequired={this.state.ccus_register_flg}
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_1_kana'
                        labelTitle={'その他1（フリガナ）'}
                        placeholder={messageUtility.getMessage('I-000-194')}
                        maxLength={120}
                        validate={validate.address_add_1_kana}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_1_kana
                        }
                        ccusRequired={this.state.ccus_register_flg}
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_2'
                        labelTitle={'その他2（建物名など）'}
                        placeholder={'（例）赤坂ビルディング'}
                        maxLength={120}
                        validate={validate.address_add_2}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_2
                        }
                      />
                      <FormEleCcus.FieldInputCommon
                        id='address_add_2_kana'
                        labelTitle={'その他2（フリガナ）'}
                        placeholder={'（例）アカサカビルディング'}
                        maxLength={120}
                        validate={validate.address_add_2_kana}
                        ccusValue={
                          this.state.ccus_field_data.field.address_add_2_kana
                        }
                      />
                      <FormListSubHeader
                        title={'事務所情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                        info={
                          <button
                            className={`btn--sub`}
                            onClick={() => {
                              this.copyFieldAddress();
                            }}
                          >
                            現場住所の内容を転記する
                          </button>
                        }
                      />
                      <FormEleCcus.OfficePostalCode
                        id='office_postal_code'
                        validate={validate.office_postal_code}
                        defaultValue={this.state.params.office_postal_code}
                        ccusValue={
                          this.state.ccus_field_data.field.office_postal_code
                        }
                      />
                      <FormEleCcus.FieldPrefecture
                        id='office_address_prefecture'
                        validate={validate.office_address_prefecture}
                        defaultValue={
                          this.state.params.office_address_prefecture
                        }
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_prefecture
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_city'
                        labelTitle={'市区町村'}
                        placeholder={messageUtility.getMessage('I-000-190')}
                        maxLength={60}
                        validate={validate.office_address_city}
                        defaultValue={this.state.params.office_address_city}
                        ccusValue={
                          this.state.ccus_field_data.field.office_address_city
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_city_kana'
                        labelTitle={'市区町村(フリガナ)'}
                        placeholder={messageUtility.getMessage('I-000-193')}
                        maxLength={60}
                        validate={validate.office_address_city_kana}
                        defaultValue={
                          this.state.params.office_address_city_kana
                        }
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_city_kana
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_1'
                        labelTitle={messageUtility.getMessage('I-000-189')}
                        placeholder={messageUtility.getMessage('I-000-192')}
                        maxLength={120}
                        validate={validate.office_address_add_1}
                        defaultValue={this.state.params.office_address_add_1}
                        ccusValue={
                          this.state.ccus_field_data.field.office_address_add_1
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_1_kana'
                        labelTitle={'その他1（フリガナ）'}
                        placeholder={messageUtility.getMessage('I-000-194')}
                        maxLength={120}
                        validate={validate.office_address_add_1_kana}
                        defaultValue={
                          this.state.params.office_address_add_1_kana
                        }
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_add_1_kana
                        }
                        required={true}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_2'
                        labelTitle={'その他2（建物名など）'}
                        placeholder={'（例）赤坂ビルディング'}
                        maxLength={120}
                        validate={validate.office_address_add_2}
                        defaultValue={this.state.params.office_address_add_2}
                        ccusValue={
                          this.state.ccus_field_data.field.office_address_add_2
                        }
                      />
                      <FormEleCcus.FieldInputCommon
                        id='office_address_add_2_kana'
                        labelTitle={'その他2（フリガナ）'}
                        placeholder={'（例）アカサカビルディング'}
                        maxLength={120}
                        validate={validate.office_address_add_2_kana}
                        defaultValue={
                          this.state.params.office_address_add_2_kana
                        }
                        ccusValue={
                          this.state.ccus_field_data.field
                            .office_address_add_2_kana
                        }
                      />
                      <FormEleCcus.OfficeTell
                        id='tel'
                        validate={validate.tel}
                        ccusValue={this.state.ccus_field_data.field.tel}
                        required={true}
                      />
                      <FormListSubHeader
                        title={'工期・労働時間情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                      />
                      <FormEleCcus.GroundBreakingDate
                        id='groundbreaking_date'
                        validate={validate.groundbreaking_date}
                        DisplayText=''
                        ccusValue={
                          this.state.ccus_field_data.field.groundbreaking_date
                        }
                      />
                      <FormEleCcus.CompleteScheduleDate
                        id='complete_schedule_date'
                        validate={validate.complete_schedule_date}
                        DisplayText=''
                        ccusValue={
                          this.state.ccus_field_data.field
                            .complete_schedule_date
                        }
                      />
                      <FormEle.BuildeeEndDay
                        disabled={false}
                        value={this.state.params.usage_end_date}
                        validate={validate.usage_end_date}
                        onUpdate={value => {
                          const key = 'usage_end_date';
                          this.setState(
                            {
                              params: {
                                ...this.state.params,
                                [key]: value,
                              },
                            },
                            () => {
                              this.FormEventMg.trigger('input_change_value', {
                                id: key,
                                value,
                              });
                              this.eachValidate({
                                id: key,
                                params: this.state.params,
                              });
                            }
                          );
                        }}
                      />
                      <FormEle.WorkTimeType
                        name='WorkTimeType'
                        defaultValue={{
                          work_hour_zone_day_flag: FIELD_WORK_HOUR_ZONES.on.id,
                          work_hour_zone_night_flag:
                            FIELD_WORK_HOUR_ZONES.on.id,
                        }}
                        validate={validate}
                      />
                      <FormEle.NestForm
                        defaultValue={this.state.params}
                        validate={validate}
                      />
                      <FormEle.DailyWorkTime
                        id='work_hour'
                        validate={validate.work_hour}
                        isRegister={true}
                      />
                      <FormListSubHeader
                        title={'管理者情報'}
                        ccusComponent={
                          this.state.ccus_field_data.field.name !== undefined &&
                          this.state.ccus_field_data.field.name !== null &&
                          this.state.ccus_field_data.field.name !== '' && (
                            <CcusTitleBlock />
                          )
                        }
                      />
                      <FormEle.ChiefName
                        id='charge_name'
                        validate={validate.charge_name}
                      />
                      <FormEle.ChiefFurigana
                        id='charge_name_kana'
                        validate={validate.charge_name_kana}
                      />
                      {/* 現場監督の時は、表示しない */}
                      <SwitchForm show={this.role_id !== USER_ROLES.manager.id}>
                        <FormEle.BuildeeTantousya
                          id='buildee_user_id'
                          fieldRegister
                          validate={validate.buildee_user_id}
                        />
                        <FormEle.BuildeeTantouEmail />
                      </SwitchForm>
                      <FormEle.Department
                        id='department'
                        validate={validate.department}
                      />
                      <FormEleCcus.FieldInputCommon
                        id='manager_id'
                        labelTitle='CCUS管理者ID'
                        placeholder='（例）12345678901234'
                        maxLength={14}
                        validate={validate.manager_id}
                        ccusValue={
                          this.state.ccus_field_data.ccus_field_managers
                            .manager_id || ''
                        }
                        ccusRequired={this.state.ccus_register_flg}
                      />
                      <FormListSubHeader title={'その他の設定'} />
                      <FormEle.StartDay
                        id='start_day'
                        validate={validate.start_day}
                      />
                      <FormEle.ApprovalDays
                        id='approval_days'
                        validate={validate.approval_days}
                      />
                      <FormEle.UsePartnerCompanyApprovalFlag
                        isRegister={true}
                        id='use_partner_company_approval_flag'
                      />
                      {/* BLDE_V2-26961
                      <FormEle.PartnerInputResultFlag
                        id='partner_input_result_flag'
                        name='PartnerInputResultFlag'
                        defaultValue={FIELD_INPUT_RESULT.on.id}
                        validate={validate.partner_input_result_flag}
                      />
                      */}
                      <FormEle.AdjustWorkPrintFlag
                        id='adjust_work_print_flag'
                        name='AdjustWorkPrintFlag'
                        defaultValue={FIELD_ADJUST_WORK_PRINT.separate.id}
                        validate={validate.adjust_work_print_flag}
                      />
                      <FormEle.CraneUsePrintFlag
                        id='crane_use_print_flag'
                        name='CraneUsePrintFlag'
                        defaultValue={FIELD_CRANE_USE_PRINT.side.id}
                        validate={validate.crane_use_print_flag}
                      />
                      <FormEle.WorkAndDiaryPrintFlag
                        id='work_and_diary_print_flag'
                        name='WorkAndDiaryPrintFlag'
                        defaultValue={FIELD_WORK_AND_DIARY_PRINT.adjustment.id}
                        validate={validate.work_and_diary_print_flag}
                      />
                      <FormEle.ManagementNo
                        id='management_no'
                        validate={validate.management_no}
                      />
                      {/* JV 追加フォーム */}
                      <FormEle.JV
                        id='jvs'
                        validate={validate.jvs}
                        defaultValue={null}
                        companyBranchId={this.state.params.company_branch_id}
                        disabled={isNullOrUndefinedOrEmptyStr(
                          this.state.params.company_branch_id
                        )}
                      />
                      <FormListSubHeader title={'利用するサービス'} />
                      <FormEle.UseEntranceSystem
                        disabled={
                          this.state.params.changeable_entrance_flg === false
                        }
                        value={this.state.params.use_entrance_flg}
                        onUpdate={(value, params) => {
                          // console.log(
                          //   'FieldRegister.jsx FormEle.UseEntranceSystem onUpdate x'
                          // );
                          this.setState({
                            params: {
                              ...this.state.params,
                              use_entrance_flg: params,
                            },
                          });
                        }}
                      />
                      <FormEle.UseGreenFileSystem
                        disabled={
                          this.state.params.changeable_greenfile_flg === false
                        }
                        value={this.state.params.use_greenfile_flg}
                        onUpdate={(value, params) => {
                          this.setState({
                            params: {
                              ...this.state.params,
                              use_greenfile_flg: params,
                            },
                          });
                        }}
                        cannotOffGreenfileFlg={
                          this.state.params.cannot_off_greenfile_flg
                        }
                      />
                      {this.state.params.changeable_progress_flg && (
                        <FormEle.UseProgressSystem
                          disabled={false}
                          value={this.state.params.use_progress_flg}
                          onUpdate={(value, params) => {
                            this.setState({
                              params: {
                                ...this.state.params,
                                use_progress_flg: params,
                              },
                            });
                          }}
                        />
                      )}
                    </Form>
                  </FormList>
                </div>

                <Modal modalRoot='root' modalState={this.state.showModal}>
                  <DialogSuccessError
                    msg={this.state.updateTitle}
                    msgDetail={this.state.updateMsg}
                    updateSuccess={this.state.updateSuccess}
                    success={() => {
                      let state = { ...this.state };
                      state.showModal = false;
                      this.setState(state);

                      if (
                        isTargetRoleId(
                          [USER_ROLES.prime, USER_ROLES.branch],
                          this.role_id
                        )
                      ) {
                        if (state.ccus_register_flg === true) {
                          state.ccusRegisterDialogShow = true;
                          this.setState(state);
                        } else {
                          if (this.shouldShowBankenDialog()) {
                            // BLDE_V2-48023 - 入退場管理機能がONの場合、BANKEN案内ダイアログを表示
                            this.setState({ isShowBankenInfoDialog: true });
                          } else {
                            _masterSlideLoader.show('Fields', {
                              state: { id: 1 },
                            });
                          }
                        }
                      } else {
                        _masterSlideLoader.show('FieldRequestList', {
                          state: { id: 1 },
                        });
                      }
                    }}
                    error={() => this.setState({ showModal: false })}
                    multilineText={true}
                  />
                </Modal>

                <CcusRegisterDialogProvider>
                  <FieldCcusRegisterDialog />
                </CcusRegisterDialogProvider>
              </div>
            </div>
          </div>
        </div>

        <Information
          title={messageUtility.getMessage('I-002-004-01')}
          message={messageUtility.getMessage('I-002-004-02')}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.ccusRegisterDialogShow}
          onClose={() => {
            if (this.shouldShowBankenDialog()) {
              // BLDE_V2-48023 - CCUS登録開始後、入退場管理機能がONの場合、BANKEN案内ダイアログを表示
              this.setState({ isShowBankenInfoDialog: true });
            } else {
              let state = { ...this.state };
              state.showModal = false;
              this.setState(state);
              _masterSlideLoader.show('Fields', {
                state: { id: 1 },
              });
            }
          }}
          multilineText={true}
        />

        <Information
          visible={this.state.duplicateRequestDialogShow}
          title={messageUtility.getMessage('E-000-053')}
          multilineText={true}
          message={this.state.updateMsg}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => {
            if (
              isTargetRoleId(
                [USER_ROLES.prime, USER_ROLES.branch],
                this.role_id
              )
            ) {
              _masterSlideLoader.show('Fields', {
                state: { id: 1 },
              });
            } else {
              _masterSlideLoader.show('FieldRequestList', {
                state: { id: 1 },
              });
            }
          }}
        />
        <Confirmation
          visible={this.state.isShowClearCcusDataConfirmDialog}
          title={messageUtility.getMessage('I-000-171')}
          message={messageUtility.getMessage('I-000-173')}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          rootClassName='dialog--wide'
          isNegative={true}
          multilineText={true}
          onCancel={() =>
            this.setState({ isShowClearCcusDataConfirmDialog: false })
          }
          onConfirm={this.clearCcusDataAndCloseConfirmDialog}
        />
        <BankenInfoDialog
          visible={this.state.isShowBankenInfoDialog}
          onClose={() => {
            _masterSlideLoader.show('Fields', {
              state: { id: 1 },
            });
          }}
        />
      </div>
    );
  }
}

/**
 * @description 一番上のヘッダー
 * @param {int} role_id ロールID
 * @param {func} close クローズダイアログ表示
 */
const FormTopHeader = ({ role_id, close }) => (
  <MasterPageHeader
    title={
      <React.Fragment>
        {isTargetRoleId([USER_ROLES.manager], role_id)
          ? '新規現場登録申請'
          : '新規現場登録'}
      </React.Fragment>
    }
    onClose={close}
  />
);

/**
 * @description ビューメニュー
 *              イベントを受け取るのでここは React.Component にする
 */
class FormViewMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validate: {},
      params: {},
      workhour_values: {},
    };
    // 必須項目ステータス
    this.requiredList_base = {
      company_branch_id: false, // 支店
      name: false, // 現場名
      address_prefecture: false, //都道府県
      address_city: false, //市区町村
      address_city_kana: false, //市区町村(フリガナ)
      address_add_1: false, //その他1（丁目・番地など）
      address_add_1_kana: false, //その他1フリガナ
      office_postal_code: false, // 事務所郵便番号
      office_address_prefecture: false, //都道府県
      office_address_city: false, //市区町村
      office_address_city_kana: false, //市区町村(フリガナ)
      office_address_add_1: false, //その他1（丁目・番地など）
      office_address_add_1_kana: false, //その他1フリガナ
      charge_name: false, // 所長名
      charge_name_kana: false, // 所長名フリガナ
      tel: false, // 事務所電話番号
      buildee_user_id: false, // Buildee担当者
      groundbreaking_date: false, // 着工日
      complete_schedule_date: false, // 竣工予定日
      // 1日あたりの労働時間
      work_hour: false,
      work_hour_zone_day_flag: false,
      work_hour_zone_night_flag: false,
      work_hour_zone_midnight_flag: false,
      usage_end_date: false, // Buildee利用終了日
      start_day: false, // 月次開始日
      approval_days: false, // 自動ロックまでの日数
      management_no: false, // 工事管理番号
      work_hour_type: false,
    };

    //ccus登録用バリデート必須項目
    this.requiredList_ccus = {
      postal_code: false, // 現場郵便番号
      ordering_type_id: false,
      construction_type_id: false,
      manager_id: false,
    };

    this.role_id = props.role_id; // ロールID
    this.isManagerRoll = isTargetRoleId([USER_ROLES.manager], this.role_id);

    this.requiredList = _.assign(
      {},
      this.requiredList_base,
      this.props.ccusChecked ? this.requiredList_ccus : {}
    );
    this.work_hours_keys = [
      'work_copy_time',
      'work_end_time',
      'work_start_time',
      'earlytime_end',
      'overtime_start',
    ];
    if (this.isManagerRoll) {
      delete this.requiredList.buildee_user_id; // 現場監督の時は消す
    }

    this.EventMg = props.EventMg;
    this.EventMg.addEventListener('change_value', (id, params) => {
      if (!Object.keys(params).length) {
        return;
      }

      if (
        id === 'company_branch_id' &&
        _.has(params, 'buildee_user_id') &&
        isTargetRoleId([USER_ROLES.prime], this.role_id)
      ) {
        // Buildee担当者を選択している状態で、支店コンポーネントが変更された場合
        this.EventMg.trigger('input_change_value', {
          id: 'buildee_user_id',
          value: '',
        });
      }
      const workhour_values = { ...this.state.workhour_values };
      _.each(this.work_hours_keys, key => {
        if (params[key]) {
          workhour_values[key] = params[key];
        }
        const key_night = `${key}_night`;
        if (params[key_night]) {
          workhour_values[key_night] = params[key_night];
        }
        const key_midnight = `${key}_midnight`;
        if (params[key_midnight]) {
          workhour_values[key_midnight] = params[key_midnight];
        }
      });
      this.setState({ workhour_values }, () => {
        if (params.work_hour_zone_day_flag) {
          _.each(this.work_hours_keys, key => {
            if (workhour_values[key]) {
              params[key] = params[key] || workhour_values[key];
            }
          });
        }
        if (params.work_hour_zone_night_flag) {
          _.each(this.work_hours_keys, key => {
            const key_night = `${key}_night`;
            if (workhour_values[key_night]) {
              params[key_night] =
                params[key_night] || workhour_values[key_night];
            }
          });
        }
        if (params.work_hour_zone_midnight_flag) {
          _.each(this.work_hours_keys, key => {
            const key_midnight = `${key}_midnight`;
            if (workhour_values[key_midnight]) {
              params[key_midnight] =
                params[key_midnight] || workhour_values[key_midnight];
            }
          });
        }
        this.validateParams(params);
      });
      this.EventMg.trigger('update_validate', { id, params });
    });
  }

  validateWorkZoneHours = (params, result) => {
    const WORK_ZONE_HOURS_FLAG = {
      DAY_FLAG: params.work_hour_zone_day_flag === 1,
      NIGHT_FLAG: params.work_hour_zone_night_flag === 1,
      MIDNIGHT_FLAG: params.work_hour_zone_midnight_flag === 1,
    };

    WORK_ZONE_HOURS_FLAG.DAY_FLAG
      ? (this.requiredList.work_hour_zone_day_flag = false)
      : delete this.requiredList.work_hour_zone_day_flag;
    WORK_ZONE_HOURS_FLAG.NIGHT_FLAG
      ? (this.requiredList.work_hour_zone_night_flag = false)
      : delete this.requiredList.work_hour_zone_night_flag;
    WORK_ZONE_HOURS_FLAG.MIDNIGHT_FLAG
      ? (this.requiredList.work_hour_zone_midnight_flag = false)
      : delete this.requiredList.work_hour_zone_midnight_flag;
    if (WORK_ZONE_HOURS_FLAG.DAY_FLAG) {
      _.each(this.work_hours_keys, key => {
        if (result.messages[key]) {
          result.messages.work_hour_zone_day_flag = '必須です。';
          return false;
        }
      });
    } else {
      delete result.messages.work_hour_zone_day_flag;
    }
    if (WORK_ZONE_HOURS_FLAG.NIGHT_FLAG) {
      _.each(this.work_hours_keys, key => {
        const k = `${key}_night`;
        if (result.messages[k]) {
          result.messages.work_hour_zone_night_flag = '必須です。';
          return false;
        }
      });
    } else {
      delete result.messages.work_hour_zone_night_flag;
    }
    if (WORK_ZONE_HOURS_FLAG.MIDNIGHT_FLAG) {
      _.each(this.work_hours_keys, key => {
        const k = `${key}_midnight`;
        if (result.messages[k]) {
          result.messages.work_hour_zone_midnight_flag = '必須です。';
          return false;
        }
      });
    } else {
      delete result.messages.work_hour_zone_midnight_flag;
    }
  };

  validateParams = (params, ccusChecked) => {
    let result = validationByJoi(
      (ccusChecked !== undefined
      ? ccusChecked
      : this.props.ccusChecked)
        ? FieldCcusScheme
        : FieldScheme,
      params
    );
    result = this.props.checkValidate(result, params);
    this.setState({ validate: result.messages, params }, () => {
      this.validateWorkZoneHours(params, result);
      this.setState({ validate: result.messages });
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.ccusChecked !== prevProps.ccusChecked) {
      this.requiredList = _.assign(
        {},
        this.requiredList_base,
        this.props.ccusChecked ? this.requiredList_ccus : {}
      );
      this.validateParams(this.state.params, this.props.ccusChecked);
    }
  }

  render() {
    const result = _.pick(this.state.validate, _.keys(this.requiredList));
    const validateResult = _.omit(this.requiredList, _.keys(result));
    const counter = _.size(_.keys(validateResult));
    const total = _.size(this.requiredList);
    const jvsError = _.has(this.state.validate, 'jvs');
    const error_style =
      _.isEmpty(this.props.validate) || (counter === total && !jvsError)
        ? { display: 'none' }
        : { color: 'red', fontSize: '15px' };

    return (
      <div className='contruction-detail-view__menu'>
        <span className='construction-detail-view__button'>
          <button
            ref={this.props.submitRef}
            id='new-field-btn-submit'
            className='btn--effective'
            onClick={() => this.EventMg.trigger('submit')}
          >
            {this.isManagerRoll ? '申請' : '登録'}
          </button>
        </span>
        {!this.isManagerRoll && !this.props.disabledCheckbox && (
          <span className='construction-detail-view__button'>
            <FieldFormCcusCheckbox
              checked={this.props.ccusChecked}
              disabled={
                this.props.disabledCheckbox || this.props.ccusSecededFlag
              }
              onChange={this.props.onChangeCcusCheckbox}
              ccusSecededFlag={this.props.ccusSecededFlag}
            />
          </span>
        )}
        <div
          className='contruction-detail-view__end-item'
          style={{ display: 'flex' }}
        >
          <div style={error_style}>
            {messageUtility.getMessage('E-000-014')}
          </div>
          {` 必須項目の入力数 ${counter}/${total}`}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldRegister.jsx